import './App.css';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import {useState} from 'react';

const numberFormatter = Intl.NumberFormat('en-us');

function InvestmentAmount(props) {
  function onChange(event) {
    const val = event.target.value;
    const strippedVal = val.replace(/[^0-9.]/g, '');
    props.setVal(strippedVal);
  }
  function onFocus() {
    setFocus(true);
  }
  function onBlur() {
    setFocus(false);
  }

  const [focused, setFocus] = useState(false);

  const value = focused
    ? props.val
    : numberFormatter.format(props.val);

  return (
    <div className="InvestmentAmount">
      <Form.Label htmlFor="investmentAmount">Investment Amount</Form.Label>
      <InputGroup className="mb-3">
        <InputGroup.Text>$</InputGroup.Text>
        <Form.Control id="investmentAmount" placeholder="" value={value} onChange={onChange} onFocus={onFocus} onBlur={onBlur}/>
      </InputGroup>
    </div>
  );
}

export default InvestmentAmount;
